import React, { useRef, useEffect } from "react";
import { defineCustomElements } from '@om-design-system/web-components/loader';

// React wrapper for Om Design System Badge web component
const OmBadge = React.forwardRef(({ 
  children,
  variant = "default",
  color = "primary",
  size = "medium",
  ...props 
}, ref) => {
  const elementRef = useRef(null);

  useEffect(() => {
    defineCustomElements();
  }, []);

  return (
    <omk-badge
      ref={(el) => {
        elementRef.current = el;
        if (ref) {
          if (typeof ref === 'function') {
            ref(el);
          } else {
            ref.current = el;
          }
        }
      }}
      variant={variant}
      color={color}
      size={size}
      {...props}
    >
      {children}
    </omk-badge>
  );
});

OmBadge.displayName = 'OmBadge';

export default OmBadge;